import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

import { IAuthListResponse } from "models/Employee/employeeManagement.model";
import { IAuthListState } from "models/Slices/authListSlice.model";
import { getAuthListsAsync } from "redux/actions/authList.action";

const initialState: IAuthListState = {
  authList: null,
  loading: false,
  error: "",
  success: false,
};

export const authListSlice = createSlice({
  name: "authList",
  initialState,
  reducers: {
    resetAuthList: () => initialState,
    resetAuthListError: (state) => {
      state.error = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAuthListsAsync.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        getAuthListsAsync.fulfilled,
        (state, action: PayloadAction<IAuthListResponse>) => {
          state.loading = false;
          state.authList = action.payload;
          state.success = !state.authList?.ErrorCode ? true : false;
        }
      )
      .addCase(getAuthListsAsync.rejected, (state, action: any) => {
        state.loading = false;
        state.error = action.error?.message;
        state.success = false;
      });
  },
});

export const { resetAuthList, resetAuthListError } = authListSlice.actions;

export const selectSuccess = (state: RootState) =>
  state.employeeManagement.success;
export const selectAgents = (state: RootState) =>
  state.employeeManagement.agents?.AgentList;

export default authListSlice.reducer;
